import React from "react";
import Imagen from "./Imagen";
import Mensaje from "./Mensaje";

const ListadoImagenes = ({ imagenes, terminoBusqueda }) => {
  if (Object.keys(imagenes).length === 0) {
    if (terminoBusqueda === "") {
      return <Mensaje mensaje={`Introduce algún término de búsqueda.`} />;
    } else {
      return (
        <Mensaje
          mensaje={`No se han encontrado resultados para "${terminoBusqueda.toLowerCase()}". Prueba con otro término.`}
        />
      );
    }
  }
  return (
    <>
      <div className="col-12 p-4 row">
        <h2>Resultados para "{terminoBusqueda.toLowerCase()}" :</h2>
      </div>
      <div className="col-12 p-4 row">
        {imagenes.map(imagen => (
          <Imagen key={imagen.id} imagen={imagen} />
        ))}
      </div>
    </>
  );
};

export default ListadoImagenes;
